module.exports = __webpack_public_path__ + "img/kehuduan.4740dafa.gif";